import PropTypes from 'prop-types';
export var defaultProps = {
  autoValidate: false,
  errorMessage: '',
  validationStatus: 'default',
  invalidDateMessage: 'Data inválida',
  invalidMaxDateMessage: 'Data maior que a data máxima',
  invalidMinDateMessage: 'Data menor que a data mínima',
  minDate: new Date(1900, 0, 1),
  maxDate: new Date(2100, 0, 1),
  value: null
};
export var propTypes = {
  autoValidate: PropTypes.bool,
  errorMessage: PropTypes.string,
  validationStatus: PropTypes.oneOf(['default', 'success', 'error']),
  invalidDateMessage: PropTypes.string,
  invalidMaxDateMessage: PropTypes.string,
  invalidMinDateMessage: PropTypes.string,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.instanceOf(Date),
  onToggleModalHandler: PropTypes.func
};